import React, { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import CloseIconButton from "../../../../components/CloseIconButton";
import { XCircleIcon } from "@heroicons/react/24/solid";
import { QrCodeIcon } from "@heroicons/react/24/solid";

interface ProdcodeFullViewProps {
  showFullView: boolean;
  closeFullView: () => void;
  producerCodeId: number;
}
export const ProdcodeFullView: React.FC<ProdcodeFullViewProps> = ({
  showFullView,
  closeFullView,
  children,
  producerCodeId,
}) => {
  return (
    <>
      <Transition appear show={showFullView} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-20 overflow-visible"
          onClose={() => {}}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25 " />
          </Transition.Child>

          <div className="flex items-center justify-center fixed inset-0 overflow-visible">
            <div className="flex items-center justify-center p-2 overflow-visible">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel
                  className="w-4/5 h-1/2 transform overflow-visible rounded bg-white border-quinary border-l-2 p-3 
               shadow-xl transition-all"
                >
                  <Dialog.Title>
                    <CloseIconButton onClick={closeFullView} />
                    <div className="flex items-center space-x-2">
                      <div>
                        <QrCodeIcon className="text-white bg-blue-500 rounded-md h-7 w-7 p-1" />
                      </div>
                      <div className="flex flex-row items-center space-x-2 text-sm ">
                        <div className="font-medium">Producer Code ID: </div>
                        <div className="">{producerCodeId}</div>
                      </div>
                    </div>
                    <div className="flex justify-between mx-2 my-2 border-secondary border-b-2" />
                    <div className="m-2 mt-4 bg-white rounded-lg box-shadow">
                      {children}
                    </div>
                  </Dialog.Title>
                  <div className="text-xs max-h-fit"></div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
};
